export const AVIATOR_QUERY_PARAM = "aviator";
export const IFRAME_TAKEOVER_MESSAGE_TYPE = "avalara-a2ui-certificate-review";
export const IFRAME_TAKEOVER_TARGET_ORIGIN_FALLBACK = "*";

export type AviatorIframeCloseAction = "cancel" | "save" | "save-as-valid" | "save-as-invalid";

const AVIATOR_ROUTE_PREFIXES = [
    "/certificate",
    "/exemptions/certificate",
    "/review",
    "/exemptions/review",
];

const DEDICATED_AVIATOR_PREFIXES = [
    "/aviator/review",
    "/aviator/certificate",
    "/exemptions/aviator/review",
    "/exemptions/aviator/certificate",
];

interface PostIframeTakeoverCloseMessageOptions {
    action: AviatorIframeCloseAction;
    certificateId?: number | string | null;
    currentWindow?: Window;
    isAviatorIframeView: boolean;
    parentWindow?: Window;
    targetOrigin?: string;
}

/**
 * Dedicated Aviator pages (`/aviator/review` and `/aviator/certificate`) hide the
 * ECM shell. This is separate from the iframe query flag, which also changes
 * review/certificate tab chrome.
 */
export function isDedicatedAviatorPage(pathname: string): boolean {
    const normalizedPathname = pathname.startsWith("/") ? pathname : `/${pathname}`;

    return DEDICATED_AVIATOR_PREFIXES.some(
        routePrefix =>
            normalizedPathname === routePrefix || normalizedPathname.startsWith(`${routePrefix}/`)
    );
}

export function isAviatorCertificateRoute(pathname: string, search: string): boolean {
    const normalizedPathname = pathname.startsWith("/") ? pathname : `/${pathname}`;

    return (
        AVIATOR_ROUTE_PREFIXES.some(
            routePrefix =>
                normalizedPathname === routePrefix ||
                normalizedPathname.startsWith(`${routePrefix}/`)
        ) && new URLSearchParams(search).get(AVIATOR_QUERY_PARAM) === "true"
    );
}

export function getIframeTakeoverTargetOrigin(referrer = document.referrer): string {
    if (!referrer) {
        return IFRAME_TAKEOVER_TARGET_ORIGIN_FALLBACK;
    }

    try {
        return new URL(referrer).origin;
    } catch {
        return IFRAME_TAKEOVER_TARGET_ORIGIN_FALLBACK;
    }
}

export function postIframeTakeoverCloseMessage({
    action,
    certificateId,
    currentWindow = window,
    isAviatorIframeView,
    parentWindow = window.parent,
    targetOrigin = getIframeTakeoverTargetOrigin(),
}: PostIframeTakeoverCloseMessageOptions): boolean {
    if (!isAviatorIframeView || parentWindow === currentWindow) {
        return false;
    }

    const payload: { action: AviatorIframeCloseAction; certificateId?: number | string } = {
        action,
    };
    if (certificateId !== null && certificateId !== undefined) {
        payload.certificateId = certificateId;
    }

    parentWindow.postMessage(
        {
            type: IFRAME_TAKEOVER_MESSAGE_TYPE,
            close: true,
            payload,
        },
        targetOrigin
    );

    return true;
}
